import axios from "axios";
import { Environment } from "../env";

const apiClient = axios.create({
  baseURL: Environment.backEndUrl,
});

apiClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("bearerToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      sessionStorage.removeItem("bearerToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
